function reloadCurrentPage(): void {
  window.location.reload();
}

// Todo - convert this to a named export
// eslint-disable-next-line import/no-default-export
export default reloadCurrentPage;
